import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignMagazinePlanList } from "@/components/features/design/magazine/list/plan";

import { useGetParams } from "./hooks/use-get-params";

export const DesignMagazinePlanListPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta
			title="マガジン記事の一覧 | プラン記事"
			url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.PLAN, { hotelID })}
		>
			<DesignMagazinePlanList hotelID={hotelID} />
		</PageMeta>
	);
};

DesignMagazinePlanListPage.displayName = "DesignMagazinePlanListPage";
